import { Reveal } from "@/components/Reveal";
import { AppBadges } from "@/components/AppBadges";
import { LeFil } from "@/components/LeFil";

export default function DownloadCTA() {
  return (
    <section className="mx-auto max-w-7xl px-5 pb-24 sm:px-8">
      <Reveal className="grain relative overflow-hidden rounded-[2.5rem] bg-indigo-deep px-8 py-16 text-center sm:px-16 sm:py-20">
        <div className="absolute -right-16 -top-16 h-64 w-64 rounded-full bg-marigold/15 blur-3xl" />
        <div className="absolute -bottom-20 -left-10 h-64 w-64 rounded-full bg-rose/10 blur-3xl" />
        <div className="relative">
          <div className="mx-auto mb-8 max-w-sm text-sand/60">
            <LeFil from="You" to="Family" showLabels className="h-auto w-full" />
          </div>
          <h2 className="mx-auto max-w-2xl font-heading text-4xl font-semibold tracking-tight text-sand sm:text-5xl">
            Bring your family closer, today
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg text-sand/75">
            Download Kinect Nova AI free on iOS and Android, and turn worry into
            peace of mind.
          </p>
          <div className="mt-8 flex justify-center">
            <AppBadges className="justify-center" onDark />
          </div>
        </div>
      </Reveal>
    </section>
  );
}
